import { Component, Input } from "@angular/core"
import { Attribute } from "../../../models/attribute.model"

@Component({
    selector: "app-premium-footer-attributions",
    templateUrl: "./footer-attributions.component.html",
    styleUrls: ["./footer-attributions.component.scss"],
    standalone: false,
})
export class FooterAttributionsComponent {
    @Input() public attributions: Attribute[]
    @Input() public credits: string
}
